/**
 * TODO make this work
 */
import React from 'react'
import './Field.css'
import Text from '../../fields/Text/Text'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import HeaderIcon from '../../fields/HeaderIcon/HeaderIcon'

export default class Field extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isSubmitting: false
    }
    this.onSubmitHandler = this.onSubmitHandler.bind(this)
  }

  onSubmitHandler() {
    // this.setState({ isSubmitting: true })
    // setTimeout(() => {
    //   this.setState({ isSubmitting: false })
    // }, 5000)
  }

  getHeader({ field }) {
    const { value, ui } = field
    if (ui && ui.icon) {
      return <h1><HeaderIcon icon={ui.icon}/> { value }</h1>
    }
    return <h1> { value }</h1>
  }

  renderField () {
    const { field } = this.props
    switch(field.type) {
      case 'title':
        return this.getHeader({ field })
      case 'text':
        return <Text field={field} />
      case 'inputText':
        return <TextField className='input-field margin30' variant='outlined' label='Your email' type='email'/>
      case 'inputTextArea':
        return <TextField className='input-field margin30' multiline variant='outlined' rowsMax="4" label='Say something' rows='4' />
      case 'submitButton':
        return <Button className='margin30' size='large' variant='contained' color='secondary' onClick={this.onSubmitHandler}>Submit</Button>
      default:
        return ''
    }
  }
  render () {
    return (
      !this.state.isSubmitting && this.renderField()
    )
  }
}